(function () {
  // Change these if you want different limits by breakpoint
  const MQ_TABLET = '(max-width: 989px)';
  const MQ_MOBILE = '(max-width: 749px)';

  function maxFirstRow(container) {
    // 1) Per-card override if you add data-max-first-row="N" in the markup
    const attr = container.getAttribute('data-max-first-row');
    if (attr && !isNaN(parseInt(attr, 10))) return parseInt(attr, 10);

    // 2) Global per-breakpoint defaults (edit to taste)
    if (window.matchMedia(MQ_MOBILE).matches) return 7;   // mobile
    if (window.matchMedia(MQ_TABLET).matches) return 6;   // tablet
    return 8;                                             // desktop
  }

  function setCount(btn, n) {
    const txt = btn.textContent;
    if (/\d+/.test(txt)) btn.textContent = txt.replace(/\d+/, String(n));
    else if (/count/i.test(txt)) btn.textContent = txt.replace(/count/gi, String(n));
    else btn.textContent = `+${n} more`;
  }

  function update(container) {
    const wrapper = container.querySelector('.product-card-swatches__wrapper');
    const btn = container.querySelector('[data-swatches-show-more]');
    if (!wrapper || !btn) return;

    const items = wrapper.querySelectorAll('[data-swatch-button]');
    if (!items.length) { btn.classList.add('hidden'); return; }

    // Reset any previous state (vendor or ours)
    container.classList.remove('product-card-swatches--collapsed', 'product-card-swatches--expanded');
    items.forEach(el => el.classList.remove('hidden'));
    btn.classList.add('hidden');
    btn.setAttribute('aria-expanded', 'false');

    // ---- SIMPLE COUNT RULE ----
    const limit = maxFirstRow(container);     // e.g., 5 on mobile
    if (items.length > limit) {
      // Hide everything after the first `limit` swatches
      for (let i = limit; i < items.length; i++) items[i].classList.add('hidden');

      const hiddenCount = items.length - limit;
      container.classList.add('product-card-swatches--collapsed');
      btn.classList.remove('hidden');
      setCount(btn, hiddenCount);

      // Reveal on click (bind once)
      if (!btn.dataset.customShowBound) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          container.classList.remove('product-card-swatches--collapsed');
          container.classList.add('product-card-swatches--expanded');
          wrapper.querySelectorAll('[data-swatch-button].hidden').forEach(el => el.classList.remove('hidden'));
          btn.classList.add('hidden');
          btn.setAttribute('aria-expanded', 'true');
        });
        btn.dataset.customShowBound = 'true';
      }
    }
  }

  function updateAll() {
    document.querySelectorAll('[data-component="product-card-swatches"]').forEach(update);
  }

  document.addEventListener('DOMContentLoaded', updateAll);
  window.addEventListener('load', updateAll);
  let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(updateAll, 120); });

  // Theme editor & dynamic sections
  document.addEventListener('shopify:section:load', updateAll);
  document.addEventListener('shopify:section:select', updateAll);
  document.addEventListener('shopify:section:deselect', updateAll);
})();
